import { axiosObject } from "../config";

function placeBid(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/place-bid`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getLatestBid(event_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBidderForEvent(params: any, event_uuid: string) {
  return new Promise((resolve, reject) => {
    let uri =
      process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? `/data/resource/eligible-bidders/_read`
        : `auction/data/resource/eligible-bidders/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: params.per_page,
        page: params.page,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function addBidderForEvent(payload: any) {
  return new Promise((resolve, reject) => {
    let uri =
      process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? `/data/resource/eligible-bidders/_create`
        : `auction/data/resource/eligible-bidders/_create`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function updateBidderForEvent(payload: any) {
  return new Promise((resolve, reject) => {
    let uri =
      process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? `/data/resource/eligible-bidders/_patch`
        : `auction/data/resource/eligible-bidders/_patch`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllBids(event_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllCities(value: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/cities/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "name",
          op: "like",
          value: value,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getAllStates(value: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/states/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "name",
          op: "like",
          value: value,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getCitiesbySlug(value: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/cities/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "slug",
          op: "in",
          value: value,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getStatesBySlug(value: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/states/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "slug",
          op: "in",
          value: value,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAssetsbySlug(value: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/asset-types/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "slug",
          op: "in",
          value: value,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllAssets(value: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/asset-types/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "name",
          op: "like",
          value: value,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllWrongBids(event_uuid: any, user_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/wrong-bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
        {
          attribute: "user_uuid",
          op: "eq",
          value: user_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getLatestBidOfUser(event_uuid: string, user_uuid: string) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
        {
          attribute: "user_uuid",
          op: "eq",
          value: user_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function deleteBidderForEvent(uuid: string) {
  return new Promise((resolve, reject) => {
    let uri =
      process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? `/data/resource/eligible-bidders/_delete`
        : `auction/data/resource/eligible-bidders/_delete`;

    let payload = {
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: uuid,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBidderByUserUuid(user_uuid: string) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/eligible-bidders/_read`;
    let payload: any = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
    };
    // if (process.env.NEXT_PUBLIC_ENABLE_FEATURE === "true") {
    payload["filterBy"] = [
      {
        attribute: "user_uuid",
        op: "eq",
        value: user_uuid,
      },
    ];
    // } else {
    //   payload["filterBy"] = [
    //     {
    //       attribute: "user_uuid",
    //       op: "eq",
    //       value: user_uuid,
    //     },
    //     // show events even when user is not verified
    //     {
    //       attribute: "status",
    //       op: "eq",
    //       value: "verified",
    //     },
    //   ];
    // }

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllBidsForBanker(event_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllWrongBidsForBanker(event_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/wrong-bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllBiddersForEvent(event_uuid: string) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/eligible-bidders/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBidderByUserUuidAndEventUuid(
  user_uuid: string,
  event_uuid: any,
  status: string
) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/eligible-bidders/_read`;
    const filterBy = [
      {
        attribute: "user_uuid",
        op: "eq",
        value: user_uuid,
      },
      {
        attribute: "event_uuid",
        op: "eq",
        value: event_uuid,
      },
    ];

    if (status === "verified") {
      filterBy.push({
        attribute: "status",
        op: "eq",
        value: "verified",
      });
    }

    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: filterBy,
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBidderByUuid(uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/eligible-bidders/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function verifyKyc(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/verify-identity";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function esignDocument(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/esign-pdf";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBidderOnboardingOfUser(user_uuid: string) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bidder-onboarding/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "user_uuid",
          op: "eq",
          value: user_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
interface CreateBidderOnboardingPayload {
  user_uuid: string;
  type: string; // individual/proprietors/partnership/company
  name: string;
  authorized_person_name: string; // NA in case of individual
  email: string;
  mobile: string;
  alternate_mobile: string;
  full_address: string;
  city: string;
  state: string;
  pin: string;
  pan: string;
  adhaar: string;
  preferred_location?: any;
  preferred_property_type?: any;
  price_range?: string; // 1 to 10 Lakhs / 10 to 50 Lakhs /50 Lakhs to 1 Cr / 1 Cr to 5 Cr / 5 Cr and Above
  // status: string // pending/approved/rejected
}

function createBidderOnboarding(payload: CreateBidderOnboardingPayload) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bidder-onboarding/_create`;
    const data = JSON.parse(JSON.stringify(payload));
    let ploc = JSON.parse(JSON.stringify([data.preferred_location]));
    let places = ploc[0]
      .filter((obj: any) => obj.value)
      .map((obj: any) => obj.value);
    data["preferred_location"] = JSON.stringify(places);
    let plos = JSON.parse(JSON.stringify([data.preferred_state]));
    let states = plos[0]
      .filter((obj: any) => obj.value)
      .map((obj: any) => obj.value);
    data["preferred_state"] = JSON.stringify(states);
    let ptype = JSON.parse(JSON.stringify([data.preferred_property_type]));
    let type = ptype[0]
      .filter((obj: any) => obj.value)
      .map((obj: any) => obj.value);
    data["preferred_property_type"] = JSON.stringify(type);
    data["type"] = data.type.value;
    data["price_range"] = data.price_range.value;
    data["adhaar"] = data.aadhar; //Adhaar Will be removed once migrations are run
    data["status"] = "active";

    axiosObject
      .post(uri, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

const createBidderOnboardingWithOutData = (payload: any) => {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bidder-onboarding/_create`;
    const data = JSON.parse(JSON.stringify(payload));
    data["status"] = "pending";

    axiosObject
      .post(uri, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
};

function updateBidderOnboardingName(payload: string) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bidder-onboarding/_patch`;
    const data = JSON.parse(JSON.stringify(payload));
    data["name"] = data?.name;
    data["preferred_location"] = JSON.stringify(data.preferred_location);
    data["preferred_property_type"] = JSON.stringify(
      data.preferred_property_type
    );
    axiosObject
      .post(uri, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
interface UpdateBidderOnboardingPayload {
  uuid: string;
  user_uuid: string;
  type: string; // individual/proprietors/partnership/company
  name: string;
  authorized_person_name: string; // NA in case of individual
  email: string;
  mobile: string;
  alternate_mobile: string;
  full_address: string;
  city: string;
  state: string;
  pin: string;
  pan: string;
  adhaar: string;
  preferred_location?: any;
  preferred_property_type?: any;
  price_range?: string; // 1 to 10 Lakhs / 10 to 50 Lakhs /50 Lakhs to 1 Cr / 1 Cr to 5 Cr / 5 Cr and Above
  status: string; // pending/approved/rejected
}
function updateBidderOnboarding(payload: UpdateBidderOnboardingPayload) {
  return new Promise((resolve, reject) => {
    let uri = `auction/data/resource/bidder-onboarding/_patch`;
    // const data = JSON.parse(JSON.stringify(payload));
    // data["preferred_location"] = JSON.stringify([data.preferred_location]);
    // data["preferred_property_type"] = JSON.stringify([
    //   data.preferred_property_type,
    // ]);
    // data["type"] = data.type.value;
    // data["price_range"] = data.price_range.value;
    // data["status"] = "under-review";
    const data = JSON.parse(JSON.stringify(payload));
    let ploc = JSON.parse(JSON.stringify([data.preferred_location]));
    let places = ploc[0]
      .filter((obj: any) => obj.value)
      .map((obj: any) => obj.value);
    data["preferred_location"] = JSON.stringify(places);
    let plos = JSON.parse(JSON.stringify([data.preferred_state]));
    let states = plos[0]
      .filter((obj: any) => obj.value)
      .map((obj: any) => obj.value);
    data["preferred_state"] = JSON.stringify(states);
    let ptype = JSON.parse(JSON.stringify([data.preferred_property_type]));
    let type = ptype[0]
      .filter((obj: any) => obj.value)
      .map((obj: any) => obj.value);
    data["preferred_property_type"] = JSON.stringify(type);
    data["type"] = data.type.value;
    data["price_range"] = data.price_range.value;
    data["adhaar"] = data.aadhar;
    data["status"] = "active";
    axiosObject
      .post(uri, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function addMobileNumber(data: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/update-attribute`;
    let payload = {
      type: "mobile_number",
      value: "+91" + data.value,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function addEmail(data: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/update-attribute`;
    let payload = {
      type: "email",
      value: data.value,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function verifyEmail(data: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/verify-attribute`;
    let payload = {
      type: "email",
      value: data.value,
      token: data.otp,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function verifyMobileNumber(data: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/verify-attribute`;
    let payload = {
      type: "mobile_number",
      value: "+91" + data.value,
      token: data.otp,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function sendOtpEmail(data: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/login/otp/initiate`;
    let payload = {
      type: "email",
      value: data.value,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        console.log("errors ", errors);
        reject(errors);
      });
  });
}

function sendOtpMobile(data: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/login/otp/initiate`;
    let payload = {
      type: "mobile_number",
      value: data.value,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        console.log("errors ", errors);
        reject(errors);
      });
  });
}

function loginOtp(data: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/login/otp`;
    let payload = {
      type: data.type,
      value: data.value,
      token: data.otp,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        console.log("errors in login otp ", errors);
        reject(errors);
      });
  });
}

export {
  placeBid,
  getLatestBid,
  getBidderForEvent,
  addBidderForEvent,
  getAllBids,
  getAllWrongBids,
  getLatestBidOfUser,
  deleteBidderForEvent,
  updateBidderForEvent,
  getBidderByUserUuid,
  getAllBidsForBanker,
  getAllWrongBidsForBanker,
  getAllBiddersForEvent,
  getAllCities,
  getAllStates,
  getCitiesbySlug,
  getStatesBySlug,
  getAllAssets,
  getAssetsbySlug,
  getBidderByUserUuidAndEventUuid,
  getBidderByUuid,
  verifyKyc,
  updateBidderOnboardingName,
  getBidderOnboardingOfUser,
  createBidderOnboarding,
  createBidderOnboardingWithOutData,
  updateBidderOnboarding,
  addMobileNumber,
  addEmail,
  verifyEmail,
  verifyMobileNumber,
  esignDocument,
  sendOtpEmail,
  sendOtpMobile,
  loginOtp,
};
